module.exports = __webpack_public_path__ + "img/ic-lightbulb.de549b5f.svg";